import { Layout, Typography, Space } from "antd";
import { KeyOutlined } from "@ant-design/icons";

const { Header } = Layout;
const { Title } = Typography;

const Navbar = () => {
    return (
        <Header className="navbar">
            <Space className="navbar_content" size="middle">
                <KeyOutlined className="navbar_icon" />
                <Title level={3} className="navbar_title">
                    Password Generator
                </Title>
            </Space>
        </Header>
    );
};

export default Navbar;
